import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Preloader from "../../components/Preloader";
import NetworkError from "../../components/NetworkError";
import { textes } from "../../constants/textes";
import { config } from "../../constants/config";
import Pagination from "../../components/Pagination";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Cash, Person, Phone } from "react-bootstrap-icons";
import Search from "../Search";
import Allretrait from "./retraitall";
import Retrait from "./retrait";

export default function Retraits() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [addstate, setAddstate] = useState(false);

    const [fetching, setFetching] = useState(false);

    const [elementsList, setElementsList] = useState([]);
    const [nbpage, setNbpage] = useState(1);
    const [nbelement, setNbelement] = useState(0);
    const [page, setPage] = useState(0);

    const [isSearch, setIsSearch] = useState(false);
    const [chaine, setChaine] = useState('');

    const [nom, setnom] = useState("");
    const [numtel, setnumtel] = useState("");
    const [montant, setmontant] = useState("");
    const [montantmax, setmontantmax] = useState("");
    const [revendeur, setrevendeur] = useState("");
    const [retenu, setretenu] = useState(1);


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const getElementsList = async (p) => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        if (user?.isFullAction || user.isAdminAction) {
            await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/withdrawalrequests?limit=${config.app.limit}&page=${p + 1}`, requestOptions).then((response) => {

                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        // console.log("resonse jsondecode", data);
                        if (data?.head) {
                            let clientarray = [];
    
                            clientarray = data?.body?.data;
                            setElementsList(clientarray);
                            setNbpage(data?.body?.pages);
                            setNbelement(data?.body?.length);
                            setLoading(false);
                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                                setLoading(false);
                            }
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    setLoading(false);
                }
    
            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                setLoading(false);
            });
        } else {
            await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/withdrawalrequests?limit=${config.app.limit}&page=${p + 1}&codeutilisateur=${user?.codeutilisateur}`, requestOptions).then((response) => {

                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        // console.log("resonse jsondecode", data);
                        if (data?.head) {
                            let clientarray = [];
    
                            clientarray = data?.body?.data;
                            setElementsList(clientarray);
                            setNbpage(data?.body?.pages);
                            setNbelement(data?.body?.length);
                            setLoading(false);
                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                                setLoading(false);
                            }
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    setLoading(false);
                }
    
            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                setLoading(false);
            });
        }

    }

    const autoSearchElement = async (c) => {
        setPage(0);
        if ((c && !isSearch) || (c && isSearch)) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("token", config.app.PUBLICKEY);
            myHeaders.append("apikey", user.token);
            myHeaders.append("cpte", user.code);
            myHeaders.append("prof", user.profil);
            myHeaders.append("conn", user.espace);


            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                // body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded)

            await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/withdrawalrequests?crit=${c}`, requestOptions).then((response) => {

                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        if (data?.head) {
                            // console.log("resonse jsondecode", data);
                            let clientarray = [];
                            clientarray = data?.body?.data;
                            setElementsList(clientarray);
                            setNbpage(data?.body?.pages);
                            setNbelement(data?.body?.length);
                            // setLoading(false);
                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                            }
                            // setLoading(false);
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    // setLoading(false);
                }

            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                // setLoading(false);
            });
        } else if (c !== "" && isSearch) {
            setIsSearch(false);
            getElementsList(page);
        } else {
            setIsSearch(false);
            getElementsList(page);
        }
    }

    const getRevendeur = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users?type=revendeur&codeutilisateur=${user?.codeutilisateur}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setmontant(Number.parseInt(body?.solde));
                        setmontantmax(Number.parseInt(body?.solde));
                        setretenu(Number.parseInt(body?.retenu));
                        setrevendeur(body?.code);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("server error", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error", err);
            }

        }).catch((err) => {
            console.log("error get reventeurs list", err);
            // setError(true);
            // setLoading(false);
        });
    }


    // comportements
    useEffect(() => {
        getElementsList(page);
        getRevendeur();
    }, []);

    useEffect(() => {
        const stimeout = setTimeout(() => {
            autoSearchElement(chaine);
        }, 1000);

        return () => clearTimeout(stimeout);
    }, [chaine]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        if (nom) urlencoded.append("nom", nom);
        if (montant) urlencoded.append("montant", Number.parseInt(montant) + Number.parseInt(((montant * retenu) / 100)));
        // if (montant) urlencoded.append("montant", Number.parseInt(montant - ((montant * retenu) / 100)));
        // if (montant) urlencoded.append("montant", montant);
        if (numtel) urlencoded.append("numtel", numtel);
        urlencoded.append("codecompterevendeur", revendeur);
        urlencoded.append("defaut", false);
        urlencoded.append("edit", true);
        urlencoded.append("etatdef", "En traitement");

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: urlencoded,
            redirect: "follow",
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/withdrawalrequests`, requestOptions).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setFetching(false);
                            showErrorMessage(data?.body?.data?.msg);
                        }
                    } else {

                        showSuccesMessage(textes.fr.siteaddedlabel);
                        setAddstate(false);
                        getElementsList(page);
                        setnom("");
                        setnumtel("");
                        setmontant("");
                        setFetching(false);
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            }
        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage(textes.fr.serviceunavaillable);
            setFetching(false);
        });
    };


    // affichages
    return (
        <div className="row">
            <div className="col-md-12">
                {loading && <Preloader />}
                {!loading && error && <NetworkError />}
                {!loading && !error && (
                    <div
                        className="col-md-12"
                        style={{
                            paddingTop: 8,
                            borderTop: "1px solid #ddd",
                            borderRadius: 8,
                        }}
                    >
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <Search
                                    chaine={chaine}
                                    setChaine={setChaine}
                                    // search={searchEmployee}
                                    placeholder="Rechercher..."
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                {addstate && <div className="card w-100 border-info mb-3">
                                    <div className="card-body alert-info">
                                        <h5 className="card-title text-info"><i className="fa fa-exclamation-circle mr-2"></i> Information</h5>
                                        <p className="card-text">La <strong>Demande de retrait</strong> consite à fournir le <strong>Numéro</strong> sur lequel le dépôt sera effectué ainsi que <strong>Nom associé au numéro</strong>, puis <strong>Le montant</strong> que vous souhaitez retirer en fonction de votre <strong>Solde</strong>. Une commission de <strong>{retenu} %</strong> est prélevée pour chaque retrait effectué.</p>
                                    </div>
                                </div>}
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        {!addstate && (
                                            <button
                                                data-toggle="tooltip"
                                                title={textes.fr.newdmretratilabel}
                                                onClick={() => setAddstate(true)}
                                                data-placement="left"
                                                className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                            >
                                                <i className="fa fa-plus mr-1"></i>{" "}
                                                <span>{textes.fr.newdmretratilabel}</span>
                                            </button>
                                        )}
                                        <h6 className="m-0 ">
                                            {addstate
                                                ? textes.fr.dmretratiinfoslabel
                                                : textes.fr.listdmretratilabel}
                                        </h6>
                                    </div>
                                    {!addstate && (
                                        <div className="card-body">
                                            <div className="table-responsive mb-3">
                                                <table className="mb-0 table table-bordered">
                                                    <thead className="bg-primary">
                                                        <tr className="bg-primary text-white">
                                                            <th className="text-center">#</th>
                                                            {(user?.isFullAction || user?.isAdminAction) && <th>Revendeur</th>}
                                                            <th>Numéro téléphone</th>
                                                            <th>Noms</th>
                                                            <th>Montant</th>
                                                            <th>Montant Perçu</th>
                                                            <th>{textes.fr.statelabel}</th>
                                                            <th>{textes.fr.addeddatelabel}</th>
                                                            <th className="text-center">
                                                                {textes.fr.actionlabel}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {elementsList.length === 0 && (
                                                            <tr style={{ borderStyle: "none" }}>
                                                                <th colSpan={(user?.isFullAction || user?.isAdminAction) ? 8 : 7} className="text-center">
                                                                    {textes.fr.nodmretratifound}
                                                                </th>
                                                            </tr>
                                                        )}
                                                        {elementsList.length > 0 &&
                                                            elementsList?.map((item, index) => (
                                                                (user?.isFullAction || user?.isAdminAction) ?
                                                                    <Allretrait
                                                                        retrait={item}
                                                                        position={config.app.limit * page + index}
                                                                        key={index}
                                                                    /> :
                                                                    <Retrait
                                                                        retrait={item}
                                                                        position={config.app.limit * page + index}
                                                                        key={index}
                                                                    />
                                                            ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <Pagination
                                                nbpage={nbpage}
                                                getList={getElementsList}
                                                page={page}
                                                setPage={setPage}
                                            />
                                        </div>
                                    )}
                                    {addstate && (
                                        <div className="card-body">
                                            <form style={{ width: "100%" }} onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <div className="row">
                                                            <div className="col-md-12 mb-3">
                                                                <div className="row">
                                                                    <div className="col-md-6 mb-3">
                                                                        <label htmlFor="numtel" className="mb-1">
                                                                            Numéro de téléphone
                                                                        </label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span className="input-group-text" id="numtel"><Phone /></span>
                                                                            <input
                                                                                type="tel"
                                                                                className="form-control"
                                                                                placeholder={textes.fr.entervaluelabel}
                                                                                value={numtel}
                                                                                onChange={(e) =>
                                                                                    setnumtel(e.target.value)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <label htmlFor="nom" className="mb-1">
                                                                            Nom associé
                                                                        </label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span
                                                                                className="input-group-text"
                                                                                id="nom"
                                                                            >
                                                                                <Person />
                                                                            </span>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder={textes.fr.entervaluelabel}
                                                                                value={nom}
                                                                                onChange={(e) =>
                                                                                    setnom(e.target.value)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="montant" className="mb-1">
                                                                            Montant à retirer
                                                                        </label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span className="input-group-text" id="montant"><Cash /></span>
                                                                            <input
                                                                                type="number"
                                                                                min={100}
                                                                                max={montantmax}
                                                                                className="form-control"
                                                                                placeholder={textes.fr.entervaluelabel}
                                                                                value={montant}
                                                                                onChange={(e) => { setmontant(e.target.value) }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="montant" className="mb-1">
                                                                            Montant retenu
                                                                        </label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span className="input-group-text" id="montant"><Cash /></span>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                placeholder={textes.fr.entervaluelabel}
                                                                                value={Number.parseInt((montant * retenu) / 100)}
                                                                                onChange={() => {}}
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4 mb-3">
                                                                        <label htmlFor="montant" className="mb-1">
                                                                            Montant total à retirer
                                                                        </label>
                                                                        <div className="input-group flex-nowrap">
                                                                            <span className="input-group-text" id="montant"><Cash /></span>
                                                                            <input
                                                                                type="number"
                                                                                min={100}
                                                                                className="form-control"
                                                                                placeholder={textes.fr.entervaluelabel}
                                                                                value={Number.parseInt(montant) + Number.parseInt(((montant * retenu) / 100))}
                                                                                onChange={() => {}}
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mt-2">
                                                        <button
                                                            type="submit"
                                                            title={textes.fr.newdmretratilabel}
                                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                            disabled={nom && numtel && montant ? false : true}
                                                        >
                                                            <i className="fa fa-check mr-2"></i>
                                                            <span>Valider</span>{" "}
                                                            {fetching && (
                                                                <Spinner
                                                                    as="span"
                                                                    animation="border"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                />
                                                            )}
                                                        </button>
                                                        <button
                                                            onClick={() => {
                                                                setAddstate(false);
                                                                getElementsList(page);
                                                                setnom("");
                                                                setnumtel("");
                                                                setmontant("");
                                                            }}
                                                            title={textes.fr.cancel}
                                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                                        >
                                                            <i className="fa fa-reply mr-1"></i>{" "}
                                                            <span>{textes.fr.cancel}</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
